import { render, staticRenderFns } from "./normalGoodsUpload.vue?vue&type=template&id=5777c108"
import script from "./normalGoodsUpload.vue?vue&type=script&lang=js"
export * from "./normalGoodsUpload.vue?vue&type=script&lang=js"
import style0 from "./normalGoodsUpload.vue?vue&type=style&index=0&id=5777c108&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports